<app-button-advanced
  class="undo-redo-button"
  [action]="undoAction"
  hotButton="Ctrl Z"
  matTooltip="{{ 'viewer.Tools.Undo' | translate }}"
  [matTooltipPosition]="'left'"
  [matTooltipDisabled]="isUndoDisabled() | async"
></app-button-advanced>
<app-button-advanced
  class="undo-redo-button"
  [action]="redoAction"
  hotButton="Ctrl Y"
  matTooltip="{{ 'viewer.Tools.Redo' | translate }}"
  [matTooltipPosition]="'above'"
  [matTooltipDisabled]="isRedoDisabled() | async"
></app-button-advanced>
